import { LENSSPECIFICATION_SET } from "../constants";


export const setLensspecifications = (key, data) => ({
    type: LENSSPECIFICATION_SET,
    payload: {
        key,
        data
    },
});